import { app } from '../../../../app';

app.service('LicenseTierDetails', modal);

/** @ngInject */
function modal($uibModal) {
    return (tiers) => {
        return $uibModal.open({
            component: 'licenseManagementTierDetails',
            resolve: {
                tiers: () => tiers,
            },
            windowClass: 'tier-details-modal-window'
        }).result;
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/tier-details/license-tier-details.modal.js